import { render, staticRenderFns } from "./ks-news-content.vue?vue&type=template&id=af9281c0"
var script = {}
import style0 from "./ks-news-content.vue?vue&type=style&index=0&id=af9281c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports